exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".border-red[_v-238eefc7]{border-color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-238eefc7&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/offers/create-edit-offers.vue
// module id = 343
// module chunks = 0